import { type PantryConfig, PantryConfigProvider } from '@side/pantry';
import { usePathname } from 'next/navigation';
import { type ReactNode, useMemo } from 'react';
import { useTrackExternalEvent } from '../analytics/use-track-event';
import { updateSessionUserFlagValue } from '../launch-darkly/updateSessionUserFlagValue';
import { useAppFlags } from '../launchdarkly/useAppFlags';

export function PantryProvider({ children }: { children: ReactNode }) {
  const featureFlags = useAppFlags();
  const nextPathname = usePathname();
  const trackEvent = useTrackExternalEvent();

  const config: PantryConfig = useMemo(
    () => ({
      featureFlags,
      nextPathname,
      trackEvent,
      updateSessionUserFlagValue,
    }),
    [featureFlags, nextPathname, trackEvent],
  );

  return (
    <PantryConfigProvider config={config}>{children}</PantryConfigProvider>
  );
}
